import {
  LoginButton
} from './login_button.component.jsx'

import {
  ProfileButton
} from './profile_button/profile_button.component'

import {
  Settings
} from './settings/settings.component'

import {
  AddressesComponent
} from './addresses/addresses.component'


import {
  CityBranchesButton,
  CityBranchChooseDialog
} from './city_branches/city_branches_button.component'

let components = {
  LoginButton,
  ProfileButton,
  Settings,
  AddressesComponent,
  CityBranchesButton,
  CityBranchChooseDialog,
}

export default components;



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/components.js